<template>
    <div
        v-if="showLoader"
        class="fixed left-0 top-0 w-screen h-screen z-[99998] flex items-center justify-center bg-black/30 backdrop-blur-[3px]"
    >
        <div class="flex justify-content-center">
            <svg class="progressspinner-spin size-16" viewBox="25 25 50 50" data-pc-section="spin" style="animation-duration: 2s;">
                <circle
                    class="progressspinner-circle"
                    cx="50"
                    cy="50"
                    r="20"
                    fill="none"
                    stroke-width="3"
                    strokeMiterlimit="10"
                    data-pc-section="circle"
                />
            </svg>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, type Ref, watch } from 'vue'

    import { useAppStore } from '@/stores/app.ts'

    // data
    const appStore = useAppStore()

    const showLoader: Ref<boolean> = ref(false)
    let loaderTimeout = 0

    // watcher
    watch(() => appStore.isLoaderActive(), (value) => {
        if (!value) {
            showLoader.value = false
            clearTimeout(loaderTimeout)
            return
        }

        if (!showLoader.value) {
            loaderTimeout = setTimeout(() => {
                showLoader.value = true
            }, 600)
        }
    }, { immediate: true })
</script>

<style scoped>
.progressspinner-spin {
  animation: progressspinner-rotate 2s linear infinite;
}
@keyframes progressspinner-rotate {
  100% {
    transform: rotate(360deg);
  }
}

.progressspinner-circle {
  stroke-dasharray: 89, 200;
  stroke-dashoffset: 0;
  stroke: var(--color-primary-400);
  animation: progressspinner-dash 1.5s ease-in-out infinite;
  stroke-linecap: round;
}
@keyframes progressspinner-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}
</style>
